enum WorkSafeBcRegularPractitionerTimeSpan {
    ZeroToSixMonths = 1,
    SevenToTwelveMonths,
    GreaterThanOneYear
}

export { WorkSafeBcRegularPractitionerTimeSpan };
